var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import SVG from './SVG';
var Icon = styled(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    path {\n        fill: #54b948;\n    }\n"], ["\n    path {\n        fill: #54b948;\n    }\n"])));
export default (function () { return (React.createElement(Icon, { viewBox: "0 0 16 16" },
    React.createElement("path", { d: "M12.9 13A7 7 0 009 1v2.1a5 5 0 012 8.9V8l-2 2v5h5l2-2h-3.1zM2 1L0 3h3.1A7 7 0 007 15v-2.1A5 5 0 015 4v4l2-2V1H2z" }))); });
var templateObject_1;
//# sourceMappingURL=Refresh.js.map